import {z} from 'zod';

// Base schema for all cards
const baseCardSchema = z.object({
  cardId: z.number().describe('The ID of the card'),
  name: z.string().describe('The name of the card'),
  description: z.string().describe('A brief description of what this card does'),
});

const addOrUpdateCardInputSchema = z.object({
  prompt: z.string().describe('The prompt to use for the card'),
  cardId: z
    .number()
    .describe(
      'The ID of the card to update. You MUST provide the card ID if you are updating an existing card.',
    ),
});

export {addOrUpdateCardInputSchema, baseCardSchema};
